import { render, staticRenderFns } from "./VRequestChangePriorityModal.vue?vue&type=template&id=72bd1b26"
import script from "./VRequestChangePriorityModal.vue?vue&type=script&lang=js"
export * from "./VRequestChangePriorityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports